<mat-form-field appearance="outline" class="w-full">
  <mat-label>{{ label }}{{ required ? ' *' : '' }}</mat-label>

  <input
    matInput
    [placeholder]="expectedFormatText()"
    [formControl]="control"
    (blur)="onInputBlur()"
    (input)="onManualInput($event)"
  />

  <mat-icon
    matSuffix
    style="color: #000; width: 20px; cursor: pointer;"
    (click)="openDatePicker()"
  >
    event
  </mat-icon>

  <mat-error *ngIf="control.hasError('required')">
    Required field
  </mat-error>
  <mat-error *ngIf="control.hasError('invalidFormat')">
    Invalid date format. Expected {{ expectedFormatText() }}
  </mat-error>
   <mat-error *ngIf="control.hasError('minDate')">
    should be after
    {{ formattedMinDate()}}
  </mat-error>
  <mat-error *ngIf="control.hasError('maxDate')">
    should be before
    {{ formattedMaxDate()}}
  </mat-error>
</mat-form-field>
